import useLoginForm from '../../hooks/useLoginForm';
import {
    LoginInput,
    LoginInputFirst,
    LoginLink,
    WholeWrapper,
    LoginTitle,
    LoginButtonWrapper,
    SignupLink,
    SignupWrapper
} from './styles'
import { FormError } from '../../globalStyles'
import Button from '../Button'


function LoginForm() {

    const { register, onSubmit, errors } = useLoginForm();

    return (
        <form onSubmit={onSubmit} aria-label="form">
            <WholeWrapper>
                <LoginTitle>Log in</LoginTitle>
                <LoginInputFirst
                    {...register("email")}
                    name="email"
                    type="email"
                    placeholder='Enter email'
                    aria-label='Email' />
                <FormError>{errors.email?.message}</FormError>
                <LoginInput
                    {...register("password")}
                    name="password"
                    type="password"
                    placeholder='Enter password'
                    aria-label='Password' />
                <FormError>{errors.password?.message}</FormError>
                <LoginButtonWrapper>
                    <Button type="submit" color='fifth'>LOG IN</Button>
                </LoginButtonWrapper>
                <LoginLink to={'/forgot'}>Forgot password?</LoginLink>
                <SignupWrapper>
                  <SignupLink to={'/signup'}> Don't have an account? Create one</SignupLink>
                </SignupWrapper>
            </WholeWrapper>
        </form>
    )
}

export default LoginForm;
